import { lazy } from 'react';

const DatamapperAppConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: '/datamapper/:section?',
      component: lazy(() => import('./DatamapperApp')),
    },
    {
      path: '/datamapper',
      component: lazy(() => import('./DatamapperApp')),
    },
  ],
};

export default DatamapperAppConfig;
